// ============================================
// Proyectos / Case studies — César Balarezo León
// ============================================
// Estructura de los 6 case studies que demuestran el posicionamiento
// "practicante-constructor". Los TEXTOS viven en i18n bajo proyectos.items.{key}
// (name, tagline, context, problem, solution, h1..hN, metrics.m1..mN).
// Aquí solo va lo no traducible: slugs, cifras, stack, colores, links.
//
// Regla editorial: los proyectos enterprise se atribuyen a una
// "operadora de telecomunicaciones rural (OIMR)" — sin nombrar la empresa.

export const PROYECTOS = [
  {
    slug: "plataforma-conversacional-enterprise",
    key: "conversacional",
    featured: true,
    color: "var(--color-blue)",
    bgSoft: "var(--color-blue-soft)",
    border: "var(--color-blue-border)",
    metrics: [
      { num: "100+", labelKey: "m1" },
      { num: "5", labelKey: "m2" },
      { num: "15+", labelKey: "m3" },
      { num: "5", labelKey: "m4" },
    ],
    highlightKeys: ["h1", "h2", "h3"],
    stack: [
      "Vertex AI",
      "Gemini 2.5 Flash",
      "Discovery Engine",
      "Dialogflow CX",
      "BigQuery",
      "Cloud Run",
      "React + TypeScript",
      "Microsoft Graph API",
      "WhatsApp Business",
    ],
    liveUrl: null,
  },
  {
    slug: "pitthope",
    key: "pitthope",
    featured: true,
    color: "var(--color-purple)",
    bgSoft: "var(--color-purple-soft)",
    border: "var(--color-purple-border)",
    metrics: [
      { num: "96", labelKey: "m1" },
      { num: "12", labelKey: "m2" },
      { num: "111", labelKey: "m3" },
      { num: "4", labelKey: "m4" },
    ],
    highlightKeys: ["h1", "h2", "h3"],
    stack: [
      "React Native + Expo",
      "TypeScript",
      "Claude (Anthropic)",
      "Gemini / Vertex AI",
      "Firestore Vector Search",
      "BigQuery",
      "Cloud Run",
      "Cloud Functions",
      "ElevenLabs",
      "HeyGen",
    ],
    liveUrl: "https://pitthope.com",
  },
  {
    slug: "asesor-legal-ia",
    key: "legal",
    featured: false,
    color: "var(--color-accent)",
    bgSoft: "var(--accent-10)",
    border: "rgba(92,224,190,0.28)",
    metrics: [],
    highlightKeys: ["h1", "h2"],
    stack: ["Gemini 2.5 Flash", "Vertex AI Search", "Cloud Run", "Cloud Storage"],
    liveUrl: null,
  },
  {
    slug: "microservicios-cloud-native",
    key: "microservicios",
    featured: false,
    color: "var(--color-green)",
    bgSoft: "var(--color-green-soft)",
    border: "var(--color-green-border)",
    metrics: [
      { num: "70+", labelKey: "m1" },
      { num: "25+", labelKey: "m2" },
      { num: "10+", labelKey: "m3" },
    ],
    highlightKeys: ["h1", "h2"],
    stack: [
      "Python (Flask + FastAPI)",
      "Docker",
      "Cloud Run",
      "Cloud Build",
      "Artifact Registry",
      "IAM",
      "Cloud Logging",
    ],
    liveUrl: null,
  },
  {
    slug: "plataforma-geoespacial-rf",
    key: "geoespacial",
    featured: false,
    color: "var(--color-orange)",
    bgSoft: "var(--color-orange-soft)",
    border: "var(--color-orange-border)",
    metrics: [
      { num: "7", labelKey: "m1" },
      { num: "1000+", labelKey: "m2" },
      { num: "6", labelKey: "m3" },
    ],
    highlightKeys: ["h1", "h2"],
    stack: [
      "Python (FastAPI)",
      "NumPy / SciPy",
      "rasterio (SRTM)",
      "BigQuery Spatial",
      "Plotly",
      "ReportLab",
      "scikit-learn / ARIMA",
    ],
    liveUrl: null,
  },
  {
    slug: "code-interpreter-seguro",
    key: "interpreter",
    featured: false,
    color: "var(--color-accent)",
    bgSoft: "var(--accent-10)",
    border: "rgba(92,224,190,0.28)",
    metrics: [
      { num: "6", labelKey: "m1" },
      { num: "5", labelKey: "m2" },
    ],
    highlightKeys: ["h1", "h2"],
    stack: [
      "Python (AST parsing)",
      "Gemini 2.5 Flash",
      "openpyxl",
      "python-docx",
      "python-pptx",
      "matplotlib",
    ],
    liveUrl: null,
  },
];

// Frentes en desarrollo — se muestran como teaser en /proyectos (sin página
// de detalle hasta que existan cifras reales que mostrar).
export const PROYECTOS_UPCOMING = [
  {
    key: "drones",
    color: "var(--color-orange)",
    bgSoft: "var(--color-orange-soft)",
    border: "var(--color-orange-border)",
    stack: ["Computer Vision", "Edge AI", "Fotogrametría", "Rutas autónomas"],
  },
  {
    key: "robotica",
    color: "var(--color-purple)",
    bgSoft: "var(--color-purple-soft)",
    border: "var(--color-purple-border)",
    stack: ["Humanoides", "Modelos VLA", "Figure 03", "Simulación"],
  },
];

export function getProyecto(slug) {
  return PROYECTOS.find((p) => p.slug === slug) || null;
}
